module.exports = __webpack_public_path__ + "img/undo-icon.1c8b0e8e.svg";